import React from 'react';

import {colors} from '../../colors/colors';

import {svgIconWrapper} from '../svg-icon-wrapper';

import LocationPinSVG from './icon-location-pin.svg';

type Props = {
    color?: string;
};

function SvgComponent(props: Props) {
    const validProps = Object.assign({}, props);
    // @ts-expect-error
    delete validProps.styles;

    return <LocationPinSVG {...validProps} color={props.color || colors.black} />;
}
SvgComponent.iconName = 'locationPin';

/**
 * @deprecated This is a legacy icon
 */
export const LocationPinIcon = svgIconWrapper(SvgComponent);
